import { Spinner, styled } from '@volkswagen-onehub/components-core';
import React from 'react';
import Vehicle from './Vehicle';
import { useAppSelector } from '../../store/hooks';

const VehiclesContainer = styled.div`
    margin-top: 2rem;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    row-gap: ${props => props.theme.size.dynamic0040};
    column-gap : ${props => props.theme.size.dynamic0040};
`;

export default () => {

    const vehicles = useAppSelector(state => state.vehicles.value);

    return (
        <VehiclesContainer>
            { vehicles?.length ? vehicles.map(vehicle => <Vehicle vehicle={vehicle} key={vehicle.model} />) : <Spinner /> }
        </VehiclesContainer>
    )
}